"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_apexcharts_1 = __importDefault(require("react-apexcharts"));
var convertToApexData_1 = require("../../util/data/convertToApexData");
var lineChartConfig_1 = require("./lineChartConfig");
var chartSection_1 = require("../chart-section/chartSection");
var chartKey_1 = require("../chart-key/chartKey");
var lineChart_styles_1 = require("./lineChart.styles");
exports.LineChart = function (props) {
    var chart = lineChartConfig_1.createLineChartConfig({
        id: props.id + "chart",
        data: convertToApexData_1.convertTimeSeriesToApexData(props.data),
        lineStyles: props.lineStyles,
        metric: props.metric,
        displayRange: props.displayRange,
        annotations: props.annotations,
        max: props.max,
        yAxisTitle: props.yAxisTitle,
        language: props.language,
        timezone: props.timezone,
    });
    var keys = props.showLegend
        ? props.lineStyles.map(function (style, index) {
            return !style.hideLegend &&
                Object.assign(style, { label: props.data[index].name }, { fill: style.filled ? style.stroke : style.fill });
        })
        : [];
    return (react_1.default.createElement(chartSection_1.ChartSection, { id: props.id, heading: props.heading, info: props.info },
        react_1.default.createElement("div", { className: lineChart_styles_1.chartWrapper },
            react_1.default.createElement(react_apexcharts_1.default, { type: "line", options: chart.options, series: chart.series, height: 270 })),
        props.showLegend && react_1.default.createElement(chartKey_1.ChartKey, { keys: keys }),
        props.children));
};
exports.LineChart.defaultProps = {
    showLegend: true,
};
